var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 14.8333C19.1668 15.2754 18.9912 15.6993 18.6787 16.0118C18.3661 16.3244 17.9422 16.5 17.5002 16.5H2.50016C2.05814 16.5 1.63421 16.3244 1.32165 16.0118C1.00909 15.6993 0.833496 15.2754 0.833496 14.8333V5.66667C0.833496 5.22464 1.00909 4.80072 1.32165 4.48816C1.63421 4.17559 2.05814 4 2.50016 4H5.8335L7.50016 1.5H12.5002L14.1668 4H17.5002C17.9422 4 18.3661 4.17559 18.6787 4.48816C18.9912 4.80072 19.1668 5.22464 19.1668 5.66667V14.8333Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 13.1667C11.8411 13.1667 13.3335 11.6743 13.3335 9.83333C13.3335 7.99238 11.8411 6.5 10.0002 6.5C8.15921 6.5 6.66683 7.99238 6.66683 9.83333C6.66683 11.6743 8.15921 13.1667 10.0002 13.1667Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.ad4a6581ea4069fee359ca1298d8d906.svg";
export { ForwardRef as ReactComponent };